import * as React from "react";
import { blogUrl, generateBlogCategoryUrl } from "../../core/paths";
import { PageCategory, Post, Tag } from "../../core/types";
import { Layout } from "../../components";
import Page from "./Page";

interface IProps {
  pageContext: {
    pageInfo: {
      title: string;
      slug: string;
    };
    paginatedArticles: Post[][];
    currentCategory: PageCategory;
    pageNumber: number;
    categories: PageCategory[];
    tags: Tag[];
  };
}

const View = ({
  pageContext: {
    paginatedArticles,
    currentCategory,
    categories,
    tags,
    ...rest
  },
}: IProps) => {
  const pageInfo = {
    slug: generateBlogCategoryUrl(currentCategory.slug),
    title: "Blog",
  };

  return (
    <Layout
      metaTitle="Blog"
      metaType="object"
      categories={categories}
      tags={tags}
    >
      <Page
        pageInfo={pageInfo}
        paginatedData={paginatedArticles}
        currentCategory={currentCategory}
        tags={tags}
        {...rest}
      />
    </Layout>
  );
};

export default View;
